<template>
  <section class="deals-grid">
    <template v-if="deals && deals.length > 0">
      <DealCard v-for="deal in deals" :key="deal._id" :deal="deal" />
    </template>

    <div class="deals-empty" v-else>
      <div class="deals-empty__icon">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3 9H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 21V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <p class="deals-empty__text">No {{ status }} deals found</p>
    </div>
  </section>
</template>

<script>
  import DealCard from "@/components/privateRaise/DealCard";
  import EmptyState from "@/components/notification/EmptyState";
  import { mapGetters } from "vuex";
  export default {
    name: "Deals",
    components: {
      EmptyState,
      DealCard,
    },
    props: {
      status: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapGetters("TokenModule", ["deals", "dealsPageInfo"]),
    },
  };
</script>

<style lang="scss" scoped>
.deals-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.deals-empty {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
  
  &__icon {
    width: 64px;
    height: 64px;
    background: #F1F5F9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94A3B8;
    margin-bottom: 16px;
  }
  
  &__text {
    font-size: 14px;
    color: #64748B;
    font-weight: 400;
  }
}
</style>
